import { FC, useEffect, useState } from 'react'
import { Outlet, useNavigate, Navigate, useLocation } from 'react-router-dom'
import { Helper } from '@utils'
import { useSelector } from 'react-redux'
import SocketProvider from '@providers/SocketProvider'
import Preview from '../preview'
import { Actions, store } from '@store'
import { Admin, User, Dashboard } from '@apis'
import LinkBankAccount from '@commons/popups/linkBankAccount'
import Queue from '@commons/popups/queue'
interface ProtectedRouteProps {
  allowedRoles: string[]
  Component: any
}
const ProtectedRoute: FC<ProtectedRouteProps> = ({
  allowedRoles,
  Component,
}) => {
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { data: user } = useSelector((state: any) => state.user)
  const modal = useSelector((state: any) => state.modal)
  const { data: appointmentConsultDashboard } = useSelector(
    (state: any) => state.appointmentConsultDashboard,
  )
  const fetchAppointmentStat = async () => {
    await Dashboard.getAppointment().catch(() => {})
  }

  const fetchUser = async () => {
    const localStorageUser = await Helper.getUser()
    store.dispatch(Actions.set('user', localStorageUser))
    if (!!localStorageUser?.id && !!localStorageUser?.role) {
      if (localStorageUser?.role === 'admin') {
        await Admin.find({
          id: localStorageUser?.id,
        }).catch(() => {})
      } else if (
        localStorageUser?.role == 'doctor' ||
        localStorageUser?.role == 'institution'
      ) {
        await User.find({
          id: localStorageUser?.id,
        })
          .then((resp) => {
            if (resp?.role !== 'admin') {
              fetchAppointmentStat()
            }
          })
          .catch(() => {})
      }
    } else {
      store.dispatch(Actions.reset('user'))
      Helper.removeUser()
      navigate('/')
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!user?.id) {
      fetchUser()
    } else {
      if (user?.role !== 'admin' && !appointmentConsultDashboard?.id) {
        fetchAppointmentStat()
      }
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  if (loading) {
    return <></>
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />
  }
  return (
    <SocketProvider>
      <Component>
        <Outlet />
      </Component>
      {!!modal?.visible && modal?.type == 'preview' && (
        <Preview
          file={modal?.file}
          onClose={() => {
            store.dispatch(Actions.reset('modal'))
          }}
        />
      )}
      {!!modal?.visible && modal?.type == 'linkAccount' && (
        <LinkBankAccount visible={modal?.visible} />
      )}
      {!!modal?.visible && modal?.type == 'queue' && (
        <Queue visible={modal?.visible} />
      )}
    </SocketProvider>
  )
}

export default ProtectedRoute
